let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jmFzX")).then(() => parcelRequire('hUMuZ'));